const POLICY_KEY_PATTERN = /^[a-z0-9-]+_\d{8}$/

/**
 * A dated policy key (e.g. `tos_20260616`) covering the Terms of Use, Privacy
 * Policy, and Buyer T&C as a group, like the undated `tos` key in sign-up.
 * Updated terms = a new key: bump `LOGIN_TERMS_POLICY_KEY` in each
 * environment's configmap (and `.env`) and deploy.
 *
 * Returns the key when valid, `null` otherwise (unset, wrong type, malformed).
 */
export const parsePolicyKey = (value: unknown): string | null =>
  typeof value === 'string' && POLICY_KEY_PATTERN.test(value) ? value : null
